export enum SportsCategories {
    NBA = 'NBA'
}